import { gql } from '@apollo/client';

export const APPROVAL_TYPE_LEVEL_UPDATED = gql`
  subscription approvalTypeLevelUpdated {
    approvalTypeLevelUpdated {
      approvalTypeId
      approvalTypeLevelId
      siteId
    }
  }
`;
